import { render, staticRenderFns } from "./CourseApplyDetails.vue?vue&type=template&id=58de5372&scoped=true&"
import script from "./CourseApplyDetails.vue?vue&type=script&lang=js&"
export * from "./CourseApplyDetails.vue?vue&type=script&lang=js&"
import style0 from "./CourseApplyDetails.vue?vue&type=style&index=0&id=58de5372&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58de5372",
  null
  
)

export default component.exports